'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dividerClassNames: function() {
        return dividerClassNames;
    },
    useDividerStyles_unstable: function() {
        return useDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const dividerClassNames = {
    root: 'fui-Divider',
    wrapper: 'fui-Divider__wrapper'
};
const contentSpacing = '12px';
const insetSpacing = '12px';
const maxStartEndLength = '8px';
const minStartEndLength = '8px;';
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bt984gj: "f122n59",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        Bh6795r: "fqerorx",
        qhf8xq: "f10pi13n",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        fsow6f: "f17mccla",
        Bcvre1j: "fyl8oag",
        Br0sdwz: "f16vkdww",
        Bn78ew0: "fhsnbul",
        li1rpt: "f1gw3sf2",
        ap17g6: "f1ly5f7u",
        B771hl4: "f1s3tz6t"
    },
    childless: {
        susq4k: "f1kyqvp9",
        Bicfajf: [
            "fzynn9s",
            "f1z0ukd1"
        ],
        jwcpgy: [
            "fekrn8e",
            "ftdg338"
        ],
        B4rk6o: "fesgyo"
    },
    start: {
        Bsft5z2: "f13zj6fq"
    },
    center: {
        Ftih45: "f1wl9k8s",
        Bsft5z2: "f13zj6fq"
    },
    end: {
        Ftih45: "f1wl9k8s"
    },
    brand: {
        sj55zd: "f16muhyy",
        Bq4z7u6: "fcbuu2a",
        Bk5zm6e: [
            "f1wdw2dr",
            "f1ttio3w"
        ],
        Bqjgrrk: "f1582fpk",
        Bm6vgfq: [
            "f1ttio3w",
            "f1wdw2dr"
        ],
        B0n5ga8: "f1ahrvm8",
        s924m2: [
            "f1cd3wbc",
            "f17hbk9y"
        ],
        B1q35kw: "fvrapl0",
        Gp14am: [
            "f17hbk9y",
            "f1cd3wbc"
        ]
    },
    "default": {
        sj55zd: "fkfq4zb",
        Bq4z7u6: "f1vccso1",
        Bk5zm6e: [
            "f1geml7w",
            "fjml6kk"
        ],
        Bqjgrrk: "f1r7kh1m",
        Bm6vgfq: [
            "fjml6kk",
            "f1geml7w"
        ],
        B0n5ga8: "f16j7guv",
        s924m2: [
            "fx01ahm",
            "fj1a37q"
        ],
        B1q35kw: "fl8d8yv",
        Gp14am: [
            "fj1a37q",
            "fx01ahm"
        ]
    },
    subtle: {
        sj55zd: "f11d4kpn",
        Bq4z7u6: "f5g06un",
        Bk5zm6e: [
            "f13sxdku",
            "f1n015lb"
        ],
        Bqjgrrk: "f1x6bl8t",
        Bm6vgfq: [
            "f1n015lb",
            "f13sxdku"
        ],
        B0n5ga8: "fvod1wy",
        s924m2: [
            "fwslg65",
            "flk0e17"
        ],
        B1q35kw: "f103fvts",
        Gp14am: [
            "flk0e17",
            "fwslg65"
        ]
    },
    strong: {
        sj55zd: "f19n0e5",
        Bq4z7u6: "f10tv6oz",
        Bk5zm6e: [
            "f16xp3sf",
            "f1seuxxq"
        ],
        Bqjgrrk: "fwrmqbx",
        Bm6vgfq: [
            "f1seuxxq",
            "f16xp3sf"
        ],
        B0n5ga8: "ft83z1f",
        s924m2: [
            "f1g4150c",
            "f192dr6e"
        ],
        B1q35kw: "f1qnawh6",
        Gp14am: [
            "f192dr6e",
            "f1g4150c"
        ]
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".fqerorx{flex-grow:1;}",
        ".f10pi13n{position:relative;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f17mccla{text-align:center;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".f16vkdww::before{display:flex;}",
        ".fhsnbul::before{flex-grow:1;}",
        ".f1gw3sf2::after{box-sizing:border-box;}",
        ".f1ly5f7u::after{display:flex;}",
        ".f1s3tz6t::after{flex-grow:1;}",
        ".f1kyqvp9::before{margin-bottom:0;}",
        ".fzynn9s::before{margin-right:0;}",
        ".f1z0ukd1::before{margin-left:0;}",
        ".fekrn8e::after{margin-left:0;}",
        ".ftdg338::after{margin-right:0;}",
        ".fesgyo::after{margin-top:0;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f16muhyy{color:var(--colorBrandForeground1);}",
        ".fcbuu2a::before{border-top-color:var(--colorBrandStroke1);}",
        ".f1wdw2dr::before{border-right-color:var(--colorBrandStroke1);}",
        ".f1ttio3w::before{border-left-color:var(--colorBrandStroke1);}",
        ".f1582fpk::before{border-bottom-color:var(--colorBrandStroke1);}",
        ".f1ahrvm8::after{border-top-color:var(--colorBrandStroke1);}",
        ".f1cd3wbc::after{border-right-color:var(--colorBrandStroke1);}",
        ".f17hbk9y::after{border-left-color:var(--colorBrandStroke1);}",
        ".fvrapl0::after{border-bottom-color:var(--colorBrandStroke1);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1vccso1::before{border-top-color:var(--colorNeutralStroke2);}",
        ".f1geml7w::before{border-right-color:var(--colorNeutralStroke2);}",
        ".fjml6kk::before{border-left-color:var(--colorNeutralStroke2);}",
        ".f1r7kh1m::before{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f16j7guv::after{border-top-color:var(--colorNeutralStroke2);}",
        ".fx01ahm::after{border-right-color:var(--colorNeutralStroke2);}",
        ".fj1a37q::after{border-left-color:var(--colorNeutralStroke2);}",
        ".fl8d8yv::after{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f5g06un::before{border-top-color:var(--colorNeutralStroke3);}",
        ".f13sxdku::before{border-right-color:var(--colorNeutralStroke3);}",
        ".f1n015lb::before{border-left-color:var(--colorNeutralStroke3);}",
        ".f1x6bl8t::before{border-bottom-color:var(--colorNeutralStroke3);}",
        ".fvod1wy::after{border-top-color:var(--colorNeutralStroke3);}",
        ".fwslg65::after{border-right-color:var(--colorNeutralStroke3);}",
        ".flk0e17::after{border-left-color:var(--colorNeutralStroke3);}",
        ".f103fvts::after{border-bottom-color:var(--colorNeutralStroke3);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f10tv6oz::before{border-top-color:var(--colorNeutralStroke1);}",
        ".f16xp3sf::before{border-right-color:var(--colorNeutralStroke1);}",
        ".f1seuxxq::before{border-left-color:var(--colorNeutralStroke1);}",
        ".fwrmqbx::before{border-bottom-color:var(--colorNeutralStroke1);}",
        ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}",
        ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}",
        ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}",
        ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}"
    ]
});
const useHorizontalStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        a9b677: "fly5x3f",
        Bdkvgpv: "f163fonl",
        B0qfbqy: "f51yk4v",
        pbipgd: "f13rof3u",
        Bm2nyyq: "f8rth92",
        xrcqlc: "f6czdpx",
        i5u598: "f1iyka9k"
    },
    inset: {
        uwmqm3: [
            "fjlbh76",
            "f11qrl6u"
        ],
        z189sj: [
            "f11qrl6u",
            "fjlbh76"
        ]
    },
    start: {
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Ftih45: "f1wl9k8s",
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        Bxwl2t9: "f1he2m4d",
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ]
    },
    center: {
        fsow6f: "f17mccla",
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ]
    },
    end: {
        fsow6f: [
            "fes3tcz",
            "f1o700av"
        ],
        Bicfajf: [
            "f1ojjlep",
            "fk1kexq"
        ],
        Bsft5z2: "f13zj6fq",
        jwcpgy: [
            "f12w1bnb",
            "f1558wlj"
        ],
        Iy66sp: "f1ayce8x"
    }
}, {
    d: [
        ".fly5x3f{width:100%;}",
        ".f163fonl::before{border-top-style:solid;}",
        ".f51yk4v::before{border-top-width:var(--strokeWidthThin);}",
        ".f13rof3u::before{min-width:8px;}",
        ".f8rth92::after{border-top-style:solid;}",
        ".f6czdpx::after{border-top-width:var(--strokeWidthThin);}",
        ".f1iyka9k::after{min-width:8px;}",
        ".fjlbh76{padding-left:12px;}",
        ".f11qrl6u{padding-right:12px;}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1ojjlep::before{margin-right:12px;}",
        ".fk1kexq::before{margin-left:12px;}",
        ".f1he2m4d::before{max-width:8px;}",
        ".f12w1bnb::after{margin-left:12px;}",
        ".f1558wlj::after{margin-right:12px;}",
        ".f17mccla{text-align:center;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1ayce8x::after{max-width:8px;}"
    ]
});
const useVerticalStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Beiy3e4: "f1vx9l62",
        sshi5w: "f16gbxbe",
        m598lv: [
            "f1yq6w5o",
            "f1jpmc5p"
        ],
        B4f6apu: [
            "f9sc749",
            "f1x8pvcy"
        ],
        zkzzav: "fhkwbjy",
        Barhvk9: [
            "flthirb",
            "ftkbnf5"
        ],
        Ihftqj: [
            "f13hvwk3",
            "f1en4csx"
        ],
        Bde111x: "f19onpk6"
    },
    inset: {
        B6of3ja: "f1xdg43u",
        jrapky: "f1jlhsmd"
    },
    withChildren: {
        sshi5w: "f1tjaq3g"
    },
    start: {
        Ftih45: "f1wl9k8s",
        susq4k: "fg2pwug",
        Bbdr6tz: "fkjtzyi",
        B4rk6o: "f8vk40g"
    },
    center: {
        susq4k: "fg2pwug",
        B4rk6o: "f8vk40g"
    },
    end: {
        susq4k: "fg2pwug",
        Bsft5z2: "f13zj6fq",
        B4rk6o: "f8vk40g",
        gn64ia: "fqg5mu5"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}",
        ".f16gbxbe{min-height:20px;}",
        ".f1yq6w5o::before{border-right-style:solid;}",
        ".f1jpmc5p::before{border-left-style:solid;}",
        ".f9sc749::before{border-right-width:var(--strokeWidthThin);}",
        ".f1x8pvcy::before{border-left-width:var(--strokeWidthThin);}",
        ".fhkwbjy::before{min-height:8px;}",
        ".flthirb::after{border-right-style:solid;}",
        ".ftkbnf5::after{border-left-style:solid;}",
        ".f13hvwk3::after{border-right-width:var(--strokeWidthThin);}",
        ".f1en4csx::after{border-left-width:var(--strokeWidthThin);}",
        ".f19onpk6::after{min-height:8px;}",
        ".f1xdg43u{margin-top:12px;}",
        ".f1jlhsmd{margin-bottom:12px;}",
        ".f1tjaq3g{min-height:84px;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".fg2pwug::before{margin-bottom:12px;}",
        ".fkjtzyi::before{max-height:8px;}",
        ".f8vk40g::after{margin-top:12px;}",
        ".f13zj6fq::after{content:\"\";}",
        ".fqg5mu5::after{max-height:8px;}"
    ]
});
const useDividerStyles_unstable = (state)=>{
    'use no memo';
    const baseStyles = useBaseStyles();
    const horizontalStyles = useHorizontalStyles();
    const verticalStyles = useVerticalStyles();
    const { alignContent, appearance, inset, vertical } = state;
    state.root.className = (0, _react.mergeClasses)(dividerClassNames.root, // Base styles
    baseStyles.base, baseStyles[alignContent], appearance && baseStyles[appearance], // Horizontal styles
    !vertical && horizontalStyles.base, !vertical && inset && horizontalStyles.inset, !vertical && horizontalStyles[alignContent], // Vertical styles
    vertical && verticalStyles.base, vertical && inset && verticalStyles.inset, vertical && verticalStyles[alignContent], vertical && state.root.children !== undefined && verticalStyles.withChildren, // Childless styles
    state.root.children === undefined && baseStyles.childless, // User provided class name
    state.root.className);
    if (state.wrapper) {
        state.wrapper.className = (0, _react.mergeClasses)(dividerClassNames.wrapper, state.wrapper.className);
    }
    return state;
};
